import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { OrderType } from '@/types/domain';
import { createIdbStorage } from './persist';

type OrderState = {
  orderType: OrderType | null;
  customerName: string | null;
  draftOrderId: string | null;
  setOrderType: (type: OrderType) => void;
  setCustomerName: (name: string | null) => void;
  setDraftOrderId: (id: string | null) => void;
  reset: () => void;
};

const initial = {
  orderType: null,
  customerName: null,
  draftOrderId: null,
} satisfies Pick<OrderState, 'orderType' | 'customerName' | 'draftOrderId'>;

export const useOrderStore = create<OrderState>()(
  persist(
    (set) => ({
      ...initial,
      setOrderType: (orderType) => set({ orderType }),
      setCustomerName: (customerName) => set({ customerName }),
      setDraftOrderId: (draftOrderId) => set({ draftOrderId }),
      reset: () => set({ ...initial }),
    }),
    {
      name: 'hanami-order',
      storage: createIdbStorage(),
      partialize: (s) =>
        ({
          orderType: s.orderType,
          customerName: s.customerName,
          draftOrderId: s.draftOrderId,
        }) as OrderState,
    },
  ),
);
